import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./skills.css";

const Skills = () => {
  return (
    <div className="skills" id="skills">
      <h1>Skills & Expertise</h1>
      <div className="skills_grid">
        <div className="skill_card">
          <h3>Core Data Science</h3>
          <ul>
            <li>Machine Learning (Supervised & Unsupervised)</li>
            <li>Predictive Modeling & Regression</li>
            <li>Classification & Clustering (K-Means, XGBoost, LightGBM)</li>
            <li>NLP & Text Processing</li>
            <li>Deep Learning & Neural Networks</li>
            <li>Geospatial Analytics & S2 Cell Indexing</li>
            <li>Time Series Analysis & Forecasting</li>
            <li>Exploratory Data Analysis & Feature Engineering</li>
            <li>A/B Testing & Statistical Analysis</li>
          </ul>
        </div>

        <div className="skill_card">
          <h3>Programming & Tools</h3>
          <ul>
            <li>Python (NumPy, Pandas, Scikit-learn, TensorFlow, PyTorch)</li>
            <li>SQL (Advanced queries, window functions, optimization)</li>
            <li>PySpark (Distributed computing at scale)</li>
            <li>Cloud Platforms (GCP, AWS, BigQuery)</li>
            <li>Data Visualization (Matplotlib, Seaborn, Plotly)</li>
            <li>ML Frameworks (XGBoost, LightGBM, CatBoost)</li>
            <li>Docker & Containerization</li>
            <li>React.js & Web Development (HTML, CSS, JavaScript)</li>
          </ul>
        </div>

        <div className="skill_card">
          <h3>Business & Domain Expertise</h3>
          <ul>
            <li>Customer Lifetime Value (LTV) & Cohort Analysis</li>
            <li>Marketing Analytics & Growth Optimization</li>
            <li>Logistics Optimization & Route Planning</li>
            <li>Fraud Detection & Risk Analytics</li>
            <li>User Segmentation & Personalization</li>
            <li>Recommendation Systems</li>
            <li>Product Analytics & KPI Development</li>
          </ul>
        </div>

        <div className="skill_card">
          <h3>Soft Skills</h3>
          <ul>
            <li>Strategic Thinking & Problem Solving</li>
            <li>Cross-functional Collaboration & Leadership</li>
            <li>Data Storytelling & Visualization</li>
            <li>Business Communication & Stakeholder Management</li>
            <li>Critical Thinking & Decision Making</li>
            <li>Documentation & Knowledge Sharing</li>
            <li>Attention to Detail & Quality Assurance</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Skills;
